import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useConnect } from 'redux-bundler-hook';
import Tooltip from 'root/components/molecules/Tooltip';
import getInitials from 'utils/initials';

import SkeletonLoader from './skeleton';
import { StyledImage, StyledUserAvatar } from './styles';

const UserAvatar = ({ className, onClick, showLoader, id, withTooltip }) => {
  const { fullUser, teamMembersById } = useConnect(
    'selectTeamMembersById',
    'selectFullUser',
  );
  const teamsLookupWithCurrentUser = {
    [fullUser.id]: fullUser,
    ...teamMembersById,
  };
  const ref = useRef(null);
  const [hover, setHover] = useState(false);

  if (showLoader) {
    return (
      <StyledUserAvatar className={className} icon>
        <SkeletonLoader />
      </StyledUserAvatar>
    );
  }

  const {
    icon,
    firstName,
    lastName,
    fullName: fullNameTemp,
    initials: initialsTemp,
  } = fullUser.id === id
    ? fullUser || {}
    : teamsLookupWithCurrentUser[id] || {};

  const fullName =
    fullNameTemp || `${firstName || ''} ${lastName || ''}`.trim();
  const initials =
    initialsTemp || getInitials({ maxInitials: 2, name: fullName });

  return (
    <StyledUserAvatar
      className={className}
      colorId={id}
      icon={icon}
      onClick={onClick}
      onMouseEnter={() => {
        if (withTooltip && fullName) setHover(true);
      }}
      onMouseLeave={() => {
        if (withTooltip && fullName) setHover(false);
      }}
      ref={ref}
    >
      <Tooltip active={hover} parent={ref} position="top" variant="arrow">
        {fullName}
      </Tooltip>
      {icon ? (
        <StyledImage alt={fullName} src={icon} title={fullName} />
      ) : (
        initials
      )}
    </StyledUserAvatar>
  );
};

UserAvatar.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  showLoader: PropTypes.bool,
  withTooltip: PropTypes.bool,
};

UserAvatar.defaultProps = {
  className: '',
  onClick: () => {},
  showLoader: false,
  withTooltip: false,
};

export default UserAvatar;
